import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-bank-icon',
  templateUrl: './bank-icon.component.html',
})

export class BankIconComponent {
  @Input() color: string = '';
}
